import { createApiClient } from "./api";
import { handleSessionExpired } from "./authRedirect";
import { getAuthToken } from "../stores/auth";

/**
 * App-wide singleton. baseUrl defaults to "" so the dev proxy in
 * vite.config.ts forwards /v1/* to the local Laravel API. Production
 * builds set VITE_API_BASE_URL at build time.
 */
const baseUrl = import.meta.env["VITE_API_BASE_URL"] ?? "";

export const apiClient = createApiClient({
  baseUrl,
  getToken: () => getAuthToken(),
  // Revoked/expired session (password changed, logout elsewhere, pruned
  // token) → wipe persisted auth + full redirect to /login?expired=1.
  onAuthError: () => handleSessionExpired(),
});
